/** Consumer display timezone — calendar-day logic for Discovery/Heute. */
export const PULSE_DISPLAY_TIMEZONE = "Europe/Zurich";

/** YYYY-MM-DD in Europe/Zurich (en-CA locale). */
export function zurichDateKey(date: Date = new Date()): string {
  return date.toLocaleDateString("en-CA", { timeZone: PULSE_DISPLAY_TIMEZONE });
}

/**
 * Calendar date (YYYY-MM-DD) of an instant in Europe/Zurich —
 * not the UTC ISO date prefix (which drifts near midnight CEST).
 */
export function extractEventDateKey(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const trimmed = iso.trim();
  const d = new Date(trimmed);
  if (!Number.isNaN(d.getTime())) {
    return d.toLocaleDateString("en-CA", { timeZone: PULSE_DISPLAY_TIMEZONE });
  }
  const match = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
  return match?.[1] ?? null;
}

/**
 * Whether an event belongs on the Discovery "Heute" / Live & Current rail.
 * Matches Web `eventMatchesFeedPeriod(..., "heute")`: Zurich calendar day of starts_at.
 * Missing starts_at → treated as heute (same as Web).
 */
export function isEventHeute(
  startsAtIso: string | null | undefined,
  todayKey: string = zurichDateKey(),
): boolean {
  const dateKey = extractEventDateKey(startsAtIso);
  if (!dateKey) return true;
  return dateKey === todayKey;
}
